<!-- ################# SITE ################## -->

<!-- Global site tag (gtag.js) - Google Analytics -->
    <script async src="https://www.googletagmanager.com/gtag/js?id=UA-151323970-1"></script>
    <script>
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'UA-151323970-1');
    </script>

<!-- bootstrap core css -->

<style src="../../assets/site/css/font-awesome.min.css"></style>
<style src="../../assets/site/css/themify-icons.css"></style>
<style src="../../assets/site/css/magnific-popup.css"></style>
<style src="../../assets/site/css/owl.theme.default.min.css"></style>
<style src="../../assets/site/css/owl.carousel.min.css"></style>
<style src="../../assets/site/css/bootstrap.min.css"></style>
<style src="../../assets/site/css/style.css"></style>
<style src="../../assets/site/css/responsive.css"></style>
<script src="../../assets/site/js/vendor/modernizr-2.8.1.min.js"></script>


    <!-- HTML5 Shim and Respond.js for IE8 support of HTML5 elements and media queries -->
    <!-- WARNING: Respond.js doesn't work if you view the page via file:// -->
    <!--[if lt IE 9]>
    <script src="js/vendor/html5shim.js"></script>
    <script src="js/vendor/respond.min.js"></script>
    <![endif]-->
<!-- ################# SITE ################## -->


    

<template>
<div id="main" class="main-content-wraper">
    <a href="https://api.whatsapp.com/send?phone=5511955707458" target="_blank" class="whatsapp"><img src="@/assets/ic-whatsapp.png" alt="Contato via Whatsapp"></a>
            <!-- Preloader -->
            <!-- <div id="preloader">
                <div id="loader"></div>
            </div> -->
            <!--end preloader-->
            <div class="custom-modal custom-modal-corona">
                <div class="shadow"></div>
                <a class="fechar">X</a>
                <div class="video-container col-12 col-md-10 col-lg-8" style="z-index:3">
                    <div class="content">
                        <div style="background:#fff" class="video-youtube">
                            <!--h5>Aviso ano 2020</h5-->
                            <img style="width:100%" src="@/assets/banner-covid19.jpg" alt="AVISO - COVID-19 | Suspensão de cobranças" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="custom-modal custom-modal-ios">
                <div class="shadow"></div>
                <a class="fechar">X</a>
                <div class="video-container col-12 col-md-10 col-lg-8" style="z-index:3">
                    <div class="content">
                        <div style="background:#fff" class="video-youtube">
                            <h5>Download do aplicativo no IOS</h5>
                            <img src="@/assets/baixar-app-ios.gif" alt="Baixar app no IOS" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="custom-modal">
                <div class="shadow"></div>
                <a class="fechar">X</a>
                <div class="video-container col-12 col-md-10 col-lg-8">
                    <div class="content">
                        <!-- <iframe class="video-youtube" width="560" height="315" src="https://www.youtube.com/embed/8ELpzmNeS4M" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/DLtee_hMVsg" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>
                </div>
            </div>
            
                
            
            <div class="main-content-inner">

                <!--start header section-->
                <header class="header">
                    <!--start navbar-->
                    <div class="navbar navbar-default navbar-fixed-top">
                        <div class="container">
                            <div class="row">
                                <div class="navbar-header page-scroll">
                                    <button type="button" class="navbar-toggle collapsed" data-toggle="collapse"
                                            data-target="#myNavbar">
                                        <span class="sr-only">Toggle navigation</span>
                                        <span class="icon-bar"></span>
                                        <span class="icon-bar"></span>
                                        <span class="icon-bar"></span>
                                    </button>
                                    <a class="navbar-brand page-scroll" href="index.html">
                                        <img src="@/assets/site/img/logo.png" alt="logo">
                                    </a>
                                </div>

                                <!-- Collect the nav links, forms, and other content for toggling -->
                                <div class="navbar-collapse collapse" id="myNavbar">
                                    <ul class="nav navbar-nav navbar-right">
                                        <li class="active"><a class="page-scroll" href="#hero" v-smooth-scroll>Sobre o app</a></li>
                                        <li><a class="page-scroll" href="#beneficios" v-smooth-scroll>Benefícios</a></li>
                                        <li><a class="page-scroll" href="#preco" v-smooth-scroll>Preço</a></li>
                                        <li><a class="page-scroll" href="#funcionalidades" v-smooth-scroll>Funcionalidades</a></li>
                                        <li><a class="page-scroll" href="#download" v-smooth-scroll>Download</a></li>
                                        <li><a class="page-scroll" href="#indique" v-smooth-scroll>Implantação</a></li>
                                        <li><a class="page-scroll" href="#contact" v-smooth-scroll>Contato</a></li>
                                    </ul>
                                </div>

                            </div>
                        </div>
                    </div>
                    <!--end navbar-->
                </header>
                <!--end header section-->

                <!--start hero section-->
                <section id="hero" class="section-lg section-hero hero-slider-section-one" style="background: url('img/hero-section-bg-2.jpg')no-repeat center center / cover">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="hero-content-wrap">
                                    <div class="hero-content typed-strings">
                                        <h1>Sobre o aplicativo</h1>
                                        <p>O InClass é um aplicativo desenvolvido para berçários, creches e pré-escolas com objetivo de simplificar a comunicação entre os pais, escola e alunos. Além de substituir a agenda de papel, o app possui diversas funcionalidades de comunicação em tempo real.</p>
                                        
                                        <div class="slider-action-btn">
                                            <span id="bntAddFnIOS">
                                                <a class="btn btn-icon"><i class="fa fa-apple"></i></a>
                                            </span>
                                            <span id="bntAddFn">
                                                <a class="btn btn-icon"><i class="fa fa-android"></i></a>
                                                <a class="btn btn-icon"><i class="fa fa-windows"></i></a>
                                            </span>
                                            <a class="video">
                                                <span class="ti-control-play"></span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="feature-image">
                                    <img src="@/assets/site/img/aplicativo-destaque.png" class="pos-hcenter img-responsive" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="section-shape">
                        <img src="@/assets/site/img/shape-bg.png" alt="shape image">
                    </div>
                </section>
                <!--end hero section-->

                <!--start product counter section-->
                <div class="product-counter-section ptb-40">
                    <div class="product-counter-wrap">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-5 col-sm-6">
                                    <div class="counter-content-wrap">
                                        <span class="ti-cup"></span>
                                        <p class="counter-title"><strong>Ativação em 3 passos</strong></p>
                                        <p>* incluso suporte dos nossos analista via Whatsapp.</p>
                                    </div>
                                </div>
                                <div class="col-md-7 col-sm-6">
                                    <ul class="counter-list list-inline text-right">
                                        <li>
                                            <span class="count">1</span>
                                            <span class="title">Entre em contato</span>
                                        </li>
                                        <li>
                                            <span class="count">2</span>
                                            <span class="title">Baixe o app</span>
                                        </li>
                                        <li>
                                            <span class="count">3</span>
                                            <span class="title">Utilize!</span>
                                        </li>

                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--end product counter section-->

                <!--start features section-->
                <section id="beneficios" class="bg-secondary ptb-90">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="section-heading text-center">
                                    <h3>Principais Benefícios</h3>
                                    <p>Conheça alguns dos principais benefícios do InClass.</p>
                                    <p>Você pode começar a usar todos esses recursos em minutos, basta entrar em contato com um de nossos consultores. </p>
                                </div>
                            </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col-md-4 col-sm-6">
                                <!--feature single start-->
                                <div class="single-feature mb-0">
                                    <div class="feature-icon">
                                        <div class="icon icon-shape bg-color white-text">
                                            <i class="fa fa-object-ungroup"></i>
                                        </div>
                                    </div>
                                    <div class="feature-content">
                                        <h5>Diário Digital</h5>
                                        <p class="mb-0">Substitui o diário de papel por um diário digital muito mais eficiente, econômico e sustentável.</p>
                                    </div>
                                </div>
                                <!--feature single end-->
                                <!--feature single start-->
                                <div class="single-feature mb-0">
                                    <div class="feature-icon">
                                        <div class="icon icon-shape bg-color white-text">
                                            <i class="fa fa-dropbox"></i>
                                        </div>
                                    </div>
                                    <div class="feature-content">
                                        <h5>Comunicação em tempo real</h5>
                                        <p class="mb-0">Os pais ou responsáveis pelo aluno receberão as informações em tempo real.</p>
                                    </div>
                                </div>
                                <!--feature single end-->
                                <!--feature single start-->
                                <div class="single-feature mb-0">
                                    <div class="feature-icon">
                                        <div class="icon icon-shape bg-color white-text">
                                            <i class="fa fa-smile-o"></i>
                                        </div>
                                    </div>
                                    <div class="feature-content">
                                        <h5>Fique por dentro!</h5>
                                        <p class="mb-0">Saiba em tempo real quando seu filho(a) chegar e sair da escola, veja fotos, eventos, comunicados e muito mais.</p>
                                    </div>
                                </div>
                                <!--feature single end-->
                            </div>
                            <div class="col-md-4 hidden-sm hidden-xs">
                                <div class="feature-image">
                                    <!-- <img src="@/assets/site/img/feature-image.png" class="pos-hcenter img-responsive" alt=""> -->
                                    <img src="@/assets/site/img/beneficios.png" class="pos-hcenter img-responsive" alt="">
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-6">
                                <!--feature single start-->
                                <div class="single-feature mb-0">
                                    <div class="feature-icon">
                                        <div class="icon icon-shape bg-color white-text">
                                            <i class="fa fa-file-archive-o"></i>
                                        </div>
                                    </div>
                                    <div class="feature-content">
                                        <h5>Melhor custo benefício</h5>
                                        <p class="mb-0">Economize! O aplicativo possui diversas funcionalidades sem custo, confira todas as funcionalidades <a href="#funcionalidades" style="text-decoration:underline">clicando aqui</a>.</p>
                                    </div>
                                </div>
                                <!--feature single end-->
                                <!--feature single start-->
                                <div class="single-feature mb-0">
                                    <div class="feature-icon">
                                        <div class="icon icon-shape bg-color white-text">
                                            <i class="fa fa-adjust"></i>
                                        </div>
                                    </div>
                                    <div class="feature-content">
                                        <h5>Dashboard</h5>
                                        <p class="mb-0">Confira de como foi o dia do seu filho(a) na escola.</p>
                                    </div>
                                </div>
                                <!--feature single end-->
                                <!--feature single start-->
                                <div class="single-feature mb-0">
                                    <div class="feature-icon">
                                        <div class="icon icon-shape bg-color white-text">
                                            <i class="fa fa-smile-o"></i>
                                        </div>
                                    </div>
                                    <div class="feature-content">
                                        <h5>Mensagens instantâneas</h5>
                                        <p class="mb-0">Comunique-se diretamente com outros pais, professores e responsáveis da escola através do chat.</p>
                                    </div>
                                </div>
                                <!--feature single end-->
                            </div>
                        </div>

                    </div>
                </section>
                <!--end features section-->

                <!--start promo section-->
                <section class="promo-section bg-secondary ptb-90">
                    <div class="promo-section-wrap">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-3 col-sm-6">
                                    <div class="single-promo-section text-center">
                                        <div class="single-promo-content">
                                            <span class="ti-face-smile  "></span>
                                            <h6>Fácil de usar</h6>
                                            <p>O aplicativo é muito simples e intuitivo, e além disso, conta também com suporte online.</p>
                                        </div>
                                        <div class="line"></div>
                                    </div>
                                </div>
                                <div class="col-md-3 col-sm-6">
                                    <div class="single-promo-section text-center">
                                        <div class="single-promo-content">
                                            <span class="ti-vector"></span>
                                            <h6>Gerenciamento de usuários</h6>
                                            <p>Somente a administração da escola terá acesso a criação de novos usuários de sua escola e controle sobre a fatura.</p>
                                        </div>
                                        <div class="line"></div>
                                    </div>
                                </div>
                                <div class="col-md-3 col-sm-6">
                                    <div class="single-promo-section text-center">
                                        <div class="single-promo-content">
                                            <span class="ti-palette"></span>
                                            <h6>Custo zero para as escolas</h6>
                                            <p>Conheça nosso plano gratuito com acesso a todos os recursos do aplicativo!</p>
                                        </div>
                                        <div class="line"></div>
                                    </div>
                                </div>
                                <div class="col-md-3 col-sm-6">
                                    <div class="single-promo-section text-center">
                                        <div class="single-promo-content">
                                            <span class="ti-headphone-alt"></span>
                                            <h6>Suporte Online</h6>
                                            <p>Suporte online das 8h00 às 18h00.</p>
                                        </div>
                                        <div class="line"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <!--end promo section-->

                <!--start app video section-->
                <div id="video-app" class="video-app-1"
                        style="background: url('img/video-play.jpg')no-repeat center center / cover">
                    <div class="overlay">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="video-play-button">
                                        <a class="video video-play mfp-iframe" data-toggle="modal"
                                        data-target="#video-popup">
                                            <span class="ti-control-play"></span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div><!-- end overlay -->
                </div>
                <!--end app video section-->

                <!--start pricing-->
                <section id="preco" class="pricing-section ptb-90">
                    <div class="pricing-section-wrap">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="section-heading text-center">
                                        <h3>Preços</h3>
                                        <p>O valor é calculado com base na <b>quantidade de alunos</b>, os demais perfis como administratores, professores e responsáveis são gratuítos.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="bg-color-sky-light">
                                    <div class="content-md container">
                                        <div class="row">
                                            <div class="col-md-4">
                                                <!--start pricing single-->
                                                <div class="pricing-single bg-secondary">
                                                    <div class="pricing-single-header">
                                                        <h4>Básico</h4>
                                                        <span>Plano gratuíto</span><br />
                                                        <ul>
                                                            <li>Possui todas as funcionalidades exceto personalização de logotipo</li>
                                                            <li>Com anúncios dos parceiros</li>
                                                            <li>Suporte somente via e-mail</li>
                                                            <li>Consultor disponível para auxiliar na utilização</li>
                                                        </ul>
                                                    </div>
                                                    <div class="pricing-single-content">
                                                        <div class="mb-40">
                                                            <span class="price-icon-sign"><i class="fa fa-dollar"></i></span>
                                                            <span class="main-price">0.</span>
                                                            <span class="sub-price">00</span>
                                                            <span style="display:none" class="main-price-info">Mês</span>
                                                        </div>
                                                        <div class="center-block">
                                                            <button type="button" href="#contact" class="softo-btn-outline">R$ 0.00  por aluno</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!--end pricing single-->
                                            </div>
                                            <div class="col-md-4">
                                                <!--start pricing single-->
                                                <div class="pricing-single bg-secondary">
                                                    <div class="pricing-single-header">
                                                        <h4>Clássico</h4>
                                                        <span style="display:none">de 61 até 99 alunos</span><br />

                                                        <ul>
                                                            <li>Possui todas as funcionalidades exceto personalização de logotipo</li>
                                                            <li>Sem anúncios</li>
                                                            <li>Suporte somente via e-mail e Whatsapp</li>
                                                            <li>Consultor disponível para auxiliar na utilização</li>
                                                        </ul>
                                                    </div>
                                                    <div class="pricing-single-content">
                                                        <div class="mb-40">
                                                            <span class="price-icon-sign"><i class="fa fa-dollar"></i></span>
                                                            <span class="main-price">3.</span>
                                                            <span class="sub-price">00</span>
                                                            <span class="main-price-info">Mês</span>
                                                        </div>
                                                        <div class="center-block">
                                                            <!-- <button type="button" class="btn softo-solid-btn">R$ 15.00 por aluno</button> -->
                                                            <button type="button" href="#contact" class="btn softo-btn-outline">R$ 3.00 por aluno</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!--end pricing single-->
                                            </div>
                                            <div class="col-md-4">
                                                <!--start pricing single-->
                                                <div class="pricing-single bg-secondary">
                                                    <div class="pricing-single-header">
                                                        <h4>Premium</h4>
                                                        <span style="display:none">Mais que 99 alunos</span><br />
                                                        <ul>
                                                            <li>Possui todas as funcionalidades</li>
                                                            <li>Sem anúncios</li>
                                                            <li>Suporte somente via e-mail e Whatsapp</li>
                                                            <li>Personalização com logotipo do cliente</li>
                                                            <li>Consultor disponível para auxiliar na utilização</li>
                                                        </ul>
                                                    </div>
                                                    
                                                    <div class="pricing-single-content">
                                                        <div class="mb-40">
                                                            <span class="price-icon-sign"><i class="fa fa-dollar"></i></span>
                                                            <span class="main-price">4.</span>
                                                            <span class="sub-price">00</span>
                                                            <span class="main-price-info">Mês</span>
                                                        </div>
                                                        
                                                        <div class="center-block">
                                                            <button type="button" href="#contact" class="btn softo-btn-outline">R$ 4.00 por aluno</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!--end pricing single-->
                                            </div>
                                        </div>
                                        <!--end row-->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <!--end pricing-->

                <!--testimonial section start-->
                <section class="testimonial-section bg-secondary ptb-90">
                    <div class="testimonial-wrap">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="section-heading text-center">
                                    <h3>Como funcionam as cobranças?</h3>
                                        <p><b>Para os planos que não são gratuítos. </b> No fechamento do mês será realizado uma contagem da <u>quantidade de usuários do tipo <b>Aluno</b></u>, com base nessa quantia será emitido um único boleto para a escola.</p>
                                        <p><i>A escola pode optar pelo repasse do valor cobrado pelo InClass para seus clientes, acrescentando o custo no valor da mensalidade escolar.</i></p>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="owl-carousel owl-theme testimonial-slider">
                                        <div class="item">
                                            <div class="single-testimonial-item">
                                                <span class="blockquote-icon"><i class="fa fa-quote-left"></i></span>
                                                <div class="testimonial-content">
                                                    <p>Professionally grow backward-compatible data without tactical alignments.
                                                        Completely whiteboard cooperative schemas rather than cross-platform
                                                        intellectual capital. Quickly benchmark wireless relationships via
                                                        client-centered models.</p>
                                                </div>
                                                <div class="testimonial-author">
                                                    <img src="@/assets/site/img/testimonial-4.png" alt="">
                                                    <div class="testimonial-author-info">
                                                        <h6>Beatrice Evans</h6>
                                                        <span>Digital Marketer</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="item">
                                            <div class="single-testimonial-item">
                                                <span class="blockquote-icon"><i class="fa fa-quote-left"></i></span>
                                                <div class="testimonial-content">
                                                    <p>Professionally grow backward-compatible data without tactical alignments.
                                                        Completely whiteboard cooperative schemas rather than cross-platform
                                                        intellectual capital. Quickly benchmark wireless relationships via
                                                        client-centered models.</p>
                                                </div>
                                                <div class="testimonial-author">
                                                    <img src="@/assets/site/img/testimonial-4.png" alt="">
                                                    <div class="testimonial-author-info">
                                                        <h6>Beatrice Evans</h6>
                                                        <span>Digital Marketer</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="item">
                                            <div class="single-testimonial-item">
                                                <span class="blockquote-icon"><i class="fa fa-quote-left"></i></span>
                                                <div class="testimonial-content">
                                                    <p>Professionally grow backward-compatible data without tactical alignments.
                                                        Completely whiteboard cooperative schemas rather than cross-platform
                                                        intellectual capital. Quickly benchmark wireless relationships via
                                                        client-centered models.</p>
                                                </div>
                                                <div class="testimonial-author">
                                                    <img src="@/assets/site/img/testimonial-4.png" alt="">
                                                    <div class="testimonial-author-info">
                                                        <h6>Beatrice Evans</h6>
                                                        <span>Digital Marketer</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="item">
                                            <div class="single-testimonial-item">
                                                <span class="blockquote-icon"><i class="fa fa-quote-left"></i></span>
                                                <div class="testimonial-content">
                                                    <p>Professionally grow backward-compatible data without tactical alignments.
                                                        Completely whiteboard cooperative schemas rather than cross-platform
                                                        intellectual capital. Quickly benchmark wireless relationships via
                                                        client-centered models.</p>
                                                </div>
                                                <div class="testimonial-author">
                                                    <img src="@/assets/site/img/testimonial-4.png" alt="">
                                                    <div class="testimonial-author-info">
                                                        <h6>Beatrice Evans</h6>
                                                        <span>Digital Marketer</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <!--testimonial section end-->

                <!--start faq section-->
                <section id="funcionalidades" class="faq-section ptb-90">
                    <div class="faq-section-wrap">
                        <div class="container">
                            <div class="section-heading">
                                <h3>Funcionalidades</h3>
                                <p style="margin-left:0">Confira todas as funcionalidades do nosso aplicativo.</p>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    
                                    <div class="panel-group" id="accordion">
                                        <!-- Start Single Item -->
                                        <div class="panel panel-default">
                                            <div class="panel-heading" id="headingOne">
                                                <h4 class="panel-title">
                                                    <a data-toggle="collapse" data-parent="#accordion" class="collapsed">
                                                        Comunicados
                                                    </a>
                                                </h4>
                                            </div>
                                            <div id="collapseOne" class="panel-collapse collapse">
                                                <div class="panel-body">
                                                    <p>Publique imediatamente ou agende comunicados para os usuários da sua escola. Com esse recurso você mantém as pessoas informadas de todos os acontecimentos importantes.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- End Single Item -->
                                        <!-- Start Single Item -->
                                        <div class="panel panel-default">
                                            <div class="panel-heading" id="headingTwo">
                                                <h4 class="panel-title">
                                                    <a class="collapsed" data-toggle="collapse" data-parent="#accordion">
                                                        Eventos
                                                    </a>
                                                </h4>
                                            </div>
                                            <div id="collapseTwo" class="panel-collapse collapse">
                                                <div class="panel-body">
                                                    <p>Publique imediatamente ou agende eventos de sua escola. Os eventos permitem a confirmação de presença e ficarão sempre visíveis em serão destaque no aplicativo ao se aproximar da data do evento.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- End Single Item -->
                                        <!-- Start Single Item -->
                                        <div class="panel panel-default">
                                            <div class="panel-heading" id="headingThree">
                                                <h4 class="panel-title">
                                                    <a class="collapsed" data-toggle="collapse" data-parent="#accordion">
                                                        Linha do tempo
                                                    </a>
                                                </h4>
                                            </div>
                                            <div id="collapseThree" class="panel-collapse collapse">
                                                <div class="panel-body">
                                                    <p>Muito comum nas redes sociais, o aplicativo oferece uma linha do tempo para que a escola publique fotos onde os usuários da escola poderão visualizar, curtir e comentar.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- End Single Item -->
                                        <!-- Start Single Item -->
                                        <div class="panel panel-default">
                                            <div class="panel-heading" id="headingFour">
                                                <h4 class="panel-title">
                                                    <a class="collapsed" data-toggle="collapse" data-parent="#accordion">
                                                        Dashboard do aluno
                                                    </a>
                                                </h4>
                                            </div>
                                            <div id="collapseFour" class="panel-collapse collapse">
                                                <div class="panel-body">
                                                    <p>Os pais e responsáveis terão acesso ao diário do aluno onde poderão escolher em ver o detalhe do dia ou um resumo mensal. Além disso, em seu perfil terá sua pontuação de engajamento.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- End Single Item -->
                                        <!-- Start Single Item -->
                                        <div class="panel panel-default">
                                            <div class="panel-heading" id="headingFour">
                                                <h4 class="panel-title">
                                                    <a class="collapsed" data-toggle="collapse" data-parent="#accordion">
                                                        Dashboard da escola
                                                    </a>
                                                </h4>
                                            </div>
                                            <div id="collapseFour" class="panel-collapse collapse">
                                                <div class="panel-body">
                                                    <p>A escola terá acesso a um dashboard com a quantidade de usuários do seu aplicativo, registro de ocorrências e o ranking de engajamento dos usuários.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- End Single Item -->
                                        <!-- Start Single Item -->
                                        <div class="panel panel-default">
                                            <div class="panel-heading" id="headingFour">
                                                <h4 class="panel-title">
                                                    <a class="collapsed" data-toggle="collapse" data-parent="#accordion">
                                                        Gameficação de engajamento
                                                    </a>
                                                </h4>
                                            </div>
                                            <div id="collapseFour" class="panel-collapse collapse">
                                                <div class="panel-body">
                                                    <p>O InClass oferece um prêmio ao usuário mais engajado do mês em sua escola. O aplicativo possui um sistema de pontuação, onde quanto mais você utilizar o aplicativo mais pontos você ganha. No final do mês, o usuário com mais pontos não precisará pagar uma mensalidade!</p>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- End Single Item -->
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="panel-group" id="accordion">
                                        <!-- Start Single Item -->
                                        <div class="panel panel-default">
                                            <div class="panel-heading" id="headingOne">
                                                <h4 class="panel-title">
                                                    <a data-toggle="collapse" data-parent="#accordion" class="collapsed">
                                                        Mensagens instantâneas
                                                    </a>
                                                </h4>
                                            </div>
                                            <div id="collapseOne" class="panel-collapse collapse">
                                                <div class="panel-body">
                                                    <p>Comunique-se em tempo real com qualquer usuário da escola através do aplicativo.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- End Single Item -->
                                        <!-- Start Single Item -->
                                        <div class="panel panel-default">
                                            <div class="panel-heading" id="headingTwo">
                                                <h4 class="panel-title">
                                                    <a class="collapsed" data-toggle="collapse" data-parent="#accordion">
                                                        Notificação de entrada
                                                    </a>
                                                </h4>
                                            </div>
                                            <div id="collapseTwo" class="panel-collapse collapse">
                                                <div class="panel-body">
                                                    <p>Cadastre de 1 a 4 pessoas responsáveis pelo aluno, dessa forma eles receberão uma notificação sempre que a criança chegar e sair da escola. </p>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- End Single Item -->
                                        <!-- Start Single Item -->
                                        <div class="panel panel-default">
                                            <div class="panel-heading" id="headingThree">
                                                <h4 class="panel-title">
                                                    <a class="collapsed" data-toggle="collapse" data-parent="#accordion">
                                                        Diário
                                                    </a>
                                                </h4>
                                            </div>
                                            <div id="collapseThree" class="panel-collapse collapse">
                                                <div class="panel-body">
                                                    <p>Saiba no detalhe tudo que seu filho fez na escola, esse recurso substitui a agenda antiga de papel.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- End Single Item -->
                                        <!-- Start Single Item -->
                                        <div class="panel panel-default">
                                            <div class="panel-heading" id="headingFour">
                                                <h4 class="panel-title">
                                                    <a class="collapsed" data-toggle="collapse" data-parent="#accordion">
                                                        Ocorrências
                                                    </a>
                                                </h4>
                                            </div>
                                            <div id="collapseFour" class="panel-collapse collapse">
                                                <div class="panel-body">
                                                    <p>Registre ocorrências que chegarão diretamente aos responsáveis da escola para que tomem providências. </p>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- End Single Item -->
                                        <!-- Start Single Item -->
                                        <div class="panel panel-default">
                                            <div class="panel-heading" id="headingFour">
                                                <h4 class="panel-title">
                                                    <a class="collapsed" data-toggle="collapse" data-parent="#accordion">
                                                        Enquete
                                                    </a>
                                                </h4>
                                            </div>
                                            <div id="collapseFour" class="panel-collapse collapse">
                                                <div class="panel-body">
                                                    <p>O aplicativo possui um recurso de perguntas com multiplas respostas para criação de pesquisas. A escola poderá criar pesquisas entre períodos personalizados para todos seus usuários, e conferir o resultado no período final.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- End Single Item -->
                                        <!-- Start Single Item -->
                                        <div class="panel panel-default">
                                            <div class="panel-heading" id="headingFour">
                                                <h4 class="panel-title">
                                                    <a class="collapsed" data-toggle="collapse" data-parent="#accordion">
                                                        Avisos
                                                    </a>
                                                </h4>
                                            </div>
                                            <div id="collapseFour" class="panel-collapse collapse">
                                                <div class="panel-body">
                                                    <p>O aplicativo exibe avisos automaticamente em determinadas nas situações. 
                                                        <ul>
                                                            <li>- Aviso de vencimento da mensalidade escolar</li>
                                                            <li>- Aviso de eventos em datas próximas</li>
                                                            <li>- Mensagem parabenizando os usuários aniversariantes</li>
                                                        </ul>
                                                     </p>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- End Single Item -->
                                    </div>
                                </div>
                                <!-- <div class="col-md-6">
                                    <div class="faq-img">
                                        <img src="@/assets/site/img/faq-right.png" class="img-responsive" alt="faq image">
                                    </div>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </section>
                <!--end faq section-->

                <!--start download section-->
                <section id="download" class="download-section" style="background: url('img/download-bg.jpg')no-repeat center center fixed">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-5 hidden-sm">
                                <div class="download-app-img">
                                    <!-- <img src="@/assets/site/img/download-app.png" alt="app download" class="img-responsive"> -->
                                    <img src="@/assets/site/img/icone-dashboard.png" alt="app download" class="img-responsive">
                                </div>
                            </div>
                            <div class="col-md-7 col-sm-12">
                                <div class="download-app-text">
                                    <h3>Baixe agora o aplicativo!</h3>
                                    <p>Os downloads são gratuítos e disponibilizados <b>exclusivamente pelo site.</b></p><br />
                                    <p>Para realizar o download, <u>acesse o site pelo celular</u> e <b>clique no botão</b> abaixo correspondente ao seu dispositivo.</p>
                                    <div class="download-app-button">
                                        <a id="bntAddFnIOS2" class="download-btn">
                                            <span class="ti-apple"></span>
                                            <p>
                                                <small>Download no</small>
                                                <br> Iphone
                                            </p>
                                        </a>
                                        <a id="download-app-button" class="download-btn">
                                            <span class="ti-android"></span>
                                            <p>
                                                <small>Download no</small>
                                                <br>Android 
                                            </p>
                                        </a>
                                        <a id="download-app-button-win" class="download-btn">
                                            <span class="ti-microsoft"></span>
                                            <p>
                                                <small>Download no</small>
                                                <br> Windows
                                            </p>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <!--end download section-->

                <!--start blog section -->
                <section id="indique" class="ptb-90 bg-secondary">
                    <div class="blog-section-wrap">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="section-heading text-center">
                                        <h3>Implantação!</h3>
                                        <p>Oferecemos todo suporte e treinamento online para que você utilize todos os recursos do aplicativo.</p>
                                        <p>Nossos consultores daram todo apoio para a implantação do aplicativo em sua escola.</p><br/>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="row">
                                <div id="sliderBlog" class="owl-carousel">
                                    <div class="single-blog-article">
                                        <div class="blog-post-img-thumb">
                                            <a href="blog-details.html" target="_blank">
                                                <img src="@/assets/site/img/blog-img1.jpg" alt="">
                                            </a>
                                        </div>
                                        <div class="blog-post-content-area">
                                            <h3><a href="blog-details.html" target="_blank">Continually reinvent
                                                competitive</a></h3>
                                            <p>Rapidiously aggregate client-focused strategic theme areas after
                                                high-quality data. Continually aggregate diverse ideas. </p>
                                            <div class="blog-footer-area">
                                                <a class="readmore-btn" href="blog-details.html" target="_blank">Read
                                                    More <i class="fa fa-angle-right"></i></a>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="single-blog-article">
                                        <div class="blog-post-img-thumb">
                                            <a href="blog-details.html" target="_blank">
                                                <img src="@/assets/site/img/blog-img2.jpg" alt="">
                                            </a>
                                        </div>
                                        <div class="blog-post-content-area">
                                            <h3><a href="blog-details.html" target="_blank">Competently impact
                                                strategic</a></h3>
                                            <p>Professionally grow technically sound technologies with fully researched
                                                metrics. Assertively embrace empowered.</p>
                                            <div class="blog-footer-area">
                                                <a class="readmore-btn" href="blog-details.html" target="_blank">Read
                                                    More <i class="fa fa-angle-right"></i></a>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="single-blog-article">
                                        <div class="blog-post-img-thumb">
                                            <a href="blog-details.html" target="_blank">
                                                <img src="@/assets/site/img/blog-img3.jpg" alt="">
                                            </a>
                                        </div>
                                        <div class="blog-post-content-area">
                                            <h3><a href="blog-details.html" target="_blank">Rapidiously predominate
                                                just</a></h3>
                                            <p>Continually fabricate magnetic interfaces through inexpensive solutions.
                                                Continually iterate distributed infomediaries. </p>
                                            <div class="blog-footer-area">
                                                <a class="readmore-btn" href="blog-details.html" target="_blank">Read
                                                    More <i class="fa fa-angle-right"></i></a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="single-blog-article">
                                        <div class="blog-post-img-thumb">
                                            <a href="blog-details.html" target="_blank">
                                                <img src="@/assets/site/img/blog-img4.jpg" alt="">
                                            </a>
                                        </div>
                                        <div class="blog-post-content-area">
                                            <h3><a href="blog-details.html" target="_blank">Interactively productize
                                                low-risk</a></h3>
                                            <p>Appropriately develop high-payoff catalysts for change after premier
                                                e-markets. Interactively maximize pandemic niche markets.</p>
                                            <div class="blog-footer-area">
                                                <a class="readmore-btn" href="blog-details.html" target="_blank">Read
                                                    More <i class="fa fa-angle-right"></i></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </section>
                <!--end blog section -->

                <!--contact us section start-->
                <section id="contact" class="contact-us ptb-90">
                    <div class="contact-us-wrap">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-5">
                                    <div class="section-heading">
                                        <h3>Entre em contato!</h3>
                                        <p>Você poderá optar pelos canais(Formulário, e-mail ou telefone/Whatsapp).</p>
                                    </div>
                                    <div class="footer-address">
                                        <!-- <h6>Head Office</h6>
                                        <p>121 King St, Melbourne VIC 3000, Australia</p> -->
                                        <ul>
                                            <li><i class="fa fa-phone"></i> <span>Whatsapp: +55 11 95570-7458</span></li>
                                            <li><i class="fa fa-envelope-o"></i> <span>Email : <a
                                                    href="mailto:contato@inclass.app">contato@inclass.app</a></span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col-md-7">
                                    <form action="php/mail.php" method="POST" id="contactForm1" class="contact-us-form" novalidate="novalidate">
                                        <h6>Deixe que nós ligamos para você!</h6>
                                        <div class="row">
                                            <div class="col-sm-6 col-xs-12">
                                                <div class="form-group">
                                                    <input type="text" class="form-control" name="name"
                                                        placeholder="Nome" v-model="nome" required="required">
                                                </div>
                                            </div>
                                            <div class="col-sm-6 col-xs-12">
                                                <div class="form-group">
                                                    <input type="email" class="form-control" name="email"
                                                        placeholder="E-mail" v-model="email" required="required">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-6 col-xs-12">
                                                <div class="form-group">
                                                    <input type="text" name="phone" value="" class="form-control"
                                                        id="phone" v-model="celular" placeholder="Celular">
                                                </div>
                                            </div>
                                            <div class="col-sm-6 col-xs-12">
                                                <div class="form-group">
                                                    <input type="text" name="company" value="" size="40"
                                                        class="form-control" v-model="escola" id="company" placeholder="Escola">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-xs-12">
                                                <div class="form-group">
                                                        <textarea name="message" id="message" class="form-control" rows="7"
                                                                cols="25" v-model="mensagem" placeholder="Mensagem"></textarea>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-12 mt-20">
                                                
                                                <v-btn color="primary" class="pull-right" @click="enviarFormularioContato" data-cy="joinSubmitBtn">Enviar</v-btn>
                                            </div>
                                        </div>
                                    </form>
                                    <p class="form-message"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <!--contact us section end-->

                <!--start footer section-->
                <footer class="footer-section bg-secondary ptb-60">
                    <div class="footer-wrap">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-6 col-md-offset-3">
                                    <div class="footer-single-col text-center">
                                        <!-- <img src="@/assets/site/img/logo-color.png" alt="footer logo"> -->
                                        <div class="footer-social-list">
                                            <ul class="list-inline">
                                                <li><a href="https://www.facebook.com/app.inclass" target="_blank"> <i class="fa fa-facebook"></i></a></li>
                                                <!-- <li><a href="#"> <i class="fa fa-twitter"></i></a></li> -->
                                                <li><a href="#"> <i class="fa fa-linkedin"></i></a></li>
                                                <!-- <li><a href="#"> <i class="fa fa-google-plus"></i></a></li> -->
                                                <li><a href="https://www.youtube.com/channel/UCpS1fZ6eIGeKLK3VUlnYibw" target="_blank"> <i class="fa fa-youtube"></i></a></li>
                                            </ul>
                                        </div>
                                        <div class="copyright-text">
                                            <p>&copy; 2020 InClass., CNPJ: 38.560.897/0001-80
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
                <!--end footer section-->
                

            </div><!--end main content inner-->
            
        </div>
        <!--end main container -->        
</template>

<!-- custom script -->
<!--script src="../../assets/site/js/scripts.js" defer></script-->

<script>
import Vue from 'vue';
import Site from '@/components/open/Site';

import db from '@/components/firebaseInit';
import firebase,{ storage } from 'firebase';

import VueMeta from 'vue-meta';
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})

import vueSmoothScroll from 'vue2-smooth-scroll'
Vue.use(vueSmoothScroll)

export default {
    name: 'cadsite',
    metaInfo: {
      title: 'Aplicativo InClass',
    //   meta: [
    //     { charset: 'utf-8' },
    //     { name: 'viewport', content: 'width=device-width, initial-scale=1' }
    //   ]
        meta: [
           { vmid: 'description', name: 'description', content: 'O aplicativo InClass é uma ferramenta que auxilia a comunicação entre a escola, os pais e alunos.' },
           { name: 'og:url', content: 'https://www.inclass.app' },
           { name: 'og:title', content: 'Aplicativo Inclass' },
           //{ name: 'og:image', content: 'https://i.catracalivre.com.br/Za23hBkAFSCnzjBMa_-LXSe8ukM=/https%3A%2F%2Fcatracalivre.com.br%2Fwp-content%2Fuploads%2F2019%2F01%2Fistock-599956378.jpg' }
           //$('head').append('<meta property="og:type" content="profile"/>'); 
            //$('head').append('<meta property="og:url" content=""/>');
            //$('head').append("<meta property='og:title' content="+text+"'/>");
            //$('head').append("<meta property='og:image' content="+imageUrl+"'/>");
        ]
    },
    data() {
        return {
            nome: '',
            telefone: '',
            email: '',
            celular: '',
            escola: '',
            mensagem: ''
        };
    },
    components: {
        Site
    },
    methods: {
        enviarFormularioContato(){
            // timestamp
                var now = new Date();
                var year = "" + now.getFullYear();
                var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
                var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
                var hour = "" + now.getHours(); if (hour.length == 1) { hour = "0" + hour; }
                var minute = "" + now.getMinutes(); if (minute.length == 1) { minute = "0" + minute; }
                var second = "" + now.getSeconds(); if (second.length == 1) { second = "0" + second; }
                //return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
                var customtimestamp = year + month + day + hour + minute + second
                db.collection('contato').add({
                    customtimestamp: customtimestamp,
                    nome: day,
                    mes: month,
                    ano: year,
                    nome: this.nome,
                    email: this.email,
                    celular: this.celular,
                    mensagem: this.mensagem
                    
                })
                .then(docRef => {
                    console.log('Document written with ID: ', docRef.id);
                    alert("Formulário enviado com sucesso. Entraremos em contato em breve!")
                    
                })
                .catch(function (error) {
                    console.log('Error adding document: ', error);
                    alert("Ops! Tivemos um probleminha ao enviar os dados do formulário. Por favor, tente novamente!")
                })
        }
    }
};




$(document).ready(function(){
    //$(".custom-modal-corona").show();


    // ### Clique para download do app
    let deferredPrompt;

    window.addEventListener('beforeinstallprompt', function(event) {
      // Prevent Chrome 67 and earlier from automatically showing the prompt
      event.preventDefault();
      // Stash the event so it can be triggered later.
      deferredPrompt = event;
    });

    // ### INICIO - para o IOS - Download
    $("#bntAddFnIOS, #bntAddFnIOS2").click(function(){
        $(".custom-modal-ios").show();
        // alert("a");
        // // Detecta se o dispositivo está no iOS
        // const isIos = () => {
        //     const userAgent = window.navigator.userAgent.toLowerCase();
        //     return /iphone|ipad|ipod/.test( userAgent );
        // }
        // // Detects if device is in standalone mode
        // const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);
        // // Verifica se deve exibir notificação popup de instalação:
        // if (isIos() && !isInStandaloneMode()) {
        //     this.setState({ showInstallMessage: true });
        // }
    })
    // ### FIM - para o IOS

    // Installation must be done by a user gesture! Here, the button click
    var btnAdd = document.getElementById("bntAddFn");
    btnAdd.addEventListener('click', (e) => {
      // hide our user interface that shows our A2HS button
      //btnAdd.style.display = 'none';
      // Show the prompt
      deferredPrompt.prompt();
      // Wait for the user to respond to the prompt
      deferredPrompt.userChoice
        .then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            console.log('User accepted the A2HS prompt');
          } else {
            console.log('User dismissed the A2HS prompt');
          }
          deferredPrompt = null;
        });
    });

    // Installation must be done by a user gesture! Here, the button click
    var btnAdd = document.getElementById("download-app-button");
    btnAdd.addEventListener('click', (e) => {
      // hide our user interface that shows our A2HS button
      //btnAdd.style.display = 'none';
      // Show the prompt
      deferredPrompt.prompt();
      // Wait for the user to respond to the prompt
      deferredPrompt.userChoice
        .then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            console.log('User accepted the A2HS prompt');
          } else {
            console.log('User dismissed the A2HS prompt');
          }
          deferredPrompt = null;
        });
    });

    // Installation must be done by a user gesture! Here, the button click
    var btnAdd = document.getElementById("download-app-button-win");
    btnAdd.addEventListener('click', (e) => {
      // hide our user interface that shows our A2HS button
      //btnAdd.style.display = 'none';
      // Show the prompt
      deferredPrompt.prompt();
      // Wait for the user to respond to the prompt
      deferredPrompt.userChoice
        .then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            console.log('User accepted the A2HS prompt');
          } else {
            console.log('User dismissed the A2HS prompt');
          }
          deferredPrompt = null;
        });
    });

    // // do action when finished install
    // window.addEventListener('appinstalled', e => {
    //     alert("O aplicativo InClass foi instalado com sucesso!")
    //     console.log("success app install!");
    // });


    $(".softo-btn-outline").click(function(){
        window.location.href = "#contact";
    })




    $(".navbar-toggle.collapsed").click(function(){
        if ($('#myNavbar').is(":visible"))
        {
            $("#myNavbar").slideUp('fast');
        }
        else{
            $("#myNavbar").slideDown('fast');
        }
        
    })

    $(".product-counter-section.ptb-40, #features, .promo-section.bg-secondary.ptb-90, #pricing, .testimonial-section.bg-secondary.ptb-90, #faqs").click(function(){
        $("#myNavbar").slideUp('fast');
    })

    $("#accordion .panel-heading").click(function(){
        if ($(this).parent().find(".collapse").is(":visible"))
        {
            $(this).parent().find("div.collapse").slideUp();
            $(this).find("h4 a").addClass("collapsed")
            $(this).find("h4 a").removeClass("collapse")
        }
        else{
            $(this).parent().find("div.collapse").slideDown();
            $(this).find("h4 a").removeClass("collapsed")
            $(this).find("h4 a").addClass("collapse")
        }
        
    })

    $("#myNavbar a").click(function(){
        $("#myNavbar").slideUp('fast');
    })

    $(".video").click(function(){
        $(".custom-modal").fadeIn("fast");
        $(".custom-modal-ios").hide();
    })

    $(".shadow, .fechar, .content").click(function(){
        $('.video-youtube').each(function(){
            var el_src = $(this).attr("src");
            $(this).attr("src",el_src);
        });
        $(".custom-modal").fadeOut("fast");
    })


    $("a").click(function(){
        gtag('event', 'clicou', {
            'event_category': '/site',
            'event_label': $(this).text()//,
            // 'value': '<value>'
        });
    })

    


// Pixel do Facebook
!function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  fbq('init', '139700983684961');
  fbq('track', 'PageView');

  // Evento do facebook - visualizaçao de conteudo    
  fbq('track', 'ViewContent');
})



</script>
<style scoped>
    ul li {
        list-style-type: circle;
        text-align: left;
    }

    .product-counter-section.ptb-40, #contact{
        background: #fff;
    }

    .btn-icon:hover, .download-btn:hover{
        cursor: pointer;
    }

    .navbar.navbar-default.navbar-fixed-top{
        padding: 3px 0 !important;
    }

    .ti-control-play{
        width:35px !important;
        height: 35px !important;
    }

    .video-play-button a{
        padding-top: 7px !important;
    }

    .custom-modal{
        text-align: center;
        position: fixed;
        width: 100%;
        height: 100%;
        z-index: 9999;
        top: 0;
        display: none;
    }

    .video-container{
        /*width: 40%;*/
        margin: auto;
        float: none !important;
    }

    .content{
        position: relative;
        padding-bottom: 56.25%; /* 16:9 */
        padding-top: 25px;
        height: 0;
    }

    .content iframe{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 9;
    }

    .fechar{
        position: fixed;
        right: 40px;
        top: 30px;
        color: #fff;
        font-size: 32px;
        z-index: 99999;
        font-weight: 100;
    }
    
    .shadow{
        background: #000;
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 2;
        /* IE 8 */
        -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=80)";

        /* IE 5-7 */
        filter: alpha(opacity=80);

        /* Netscape */
        -moz-opacity: 0.8;

        /* Safari 1.x */
        -khtml-opacity: 0.8;

        /* Good browsers */
        opacity: 0.8;
    }

    .whatsapp{
        position: fixed;
        right: 5px;
        bottom: 5px;
        z-index: 99999999;
    }

    .product-counter-section .counter-list li{
        margin: 0 20px !important;
    }

    .navbar-brand.page-scroll{
        padding-top: 9px
    }

    @-moz-document url-prefix() {
        #video-app {
            height: 470px;
        }
    }

</style>